var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content-col"
  }, [_c('Input', {
    staticClass: "content_search",
    attrs: {
      "search": "",
      "clearable": "",
      "placeholder": $t("3qpvsa5", "输入关键字")
    },
    model: {
      value: _vm.search.value,
      callback: function ($$v) {
        _vm.$set(_vm.search, "value", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "search.value"
    }
  }), _c('Tree', {
    attrs: {
      "data": _vm.data,
      "emptyText": $t("dcv57g4", "暂无数据")
    },
    on: {
      "on-select-change": _vm.onSelectChangeTree
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };